import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";


import { Input } from "@chakra-ui/react";

import axios from 'axios';


import ChilMNodal from "../childModal/childModal";

import Shablon from "../shablon/shablon.jsx";

import Metka from "../metka/metka.jsx";
import Status from "../status/status.jsx";

import SelectMarketPlace from "../selectMarketPlace/selectMarketPlace";
import "./addTask.css"
import "./addTaskDark.css"
import UploadFileTaskMeneger from "../uploadFile/uploadFile";

import Perfomer from "../perfomer/perfomer";
import CommentBoxCreatTask from "../commentCreatTask/commentCreatTask";

import Prioritet from "../prioritet/prioritet";
import { useNavigate } from "react-router";
import LoopingTask from "../loopingTask/loopingTask.jsx";
import { fetchUsers } from "../../../../redux/reducer/postFetcReducer/action/action.js";
import sockets from "../../../../socket/socket.js";

const socket = sockets;

function CreatTask({ sendMessage,receivedMessages,handleDelet,delLoad,update,handleGetNotify }) {





  const [show, setShow] = useState(false);
  const [child, setChild] = useState([]);
  const [message, setMessage] = useState("");
  const navigate = useNavigate()


  const handleClose = () => {
   
    setCurrentTask([])
    setComments([])
    setcommentsVal("")
    setperformer([])
    satTtaskName("")
    setMetka([])
    setTasktaskInfo("")
    setOzon([])
    setBw([])
    setfile(null)
    setperfomerID([])
    setchildPerfomer([])
    setChild([])
    setShow(false)

  };
  const handleShow = () => setShow(true);

  const [currentTask, setCurrentTask] = useState([]);
  const [comments, setComments] = useState([]);
  const [commentsVal, setcommentsVal] = useState("");
  const [performer, setperformer] = useState([]);
  const [templates, satTemplates] = useState("");
  const [taskName, satTtaskName] = useState("");
  const [templatesArray, satTemplatesArray] = useState([]);
  const myModalEditTask = useRef(null)
  const currentDate = new Date();
  const adjustedDate = new Date(currentDate.getTime() - currentDate.getTimezoneOffset() * 60000);
  const formattedDate = adjustedDate.toISOString().slice(0, 16);
  const [startDate, setStartDate] = useState(formattedDate);
  const [endDate, setEndDate] = useState(formattedDate);
  const [status, setStatus] = useState("Запланирована");
  const [prioritet, setPrioritet] = useState("Низший");
  const [metka, setMetka] = useState([]);
  const [taskInfo, setTasktaskInfo] = useState("");
  const [ozon, setOzon] = useState([]);
  const [wb, setBw] = useState([]);
  const [file, setfile] = useState(null);
  const [classNameTask, setclassNameTask] = useState("greyClass");
  const [users, setUsers] = useState([]);
  const subTaskRed = useRef(null);
  const firstFieldRef = useRef(null);
  const templatesRef = useRef(null);
  const [perfomerID, setperfomerID] = useState([]);
  const [childPerfomer,setchildPerfomer]=useState([])
  const [load,setLoad] = useState(false)
  const [onlineUsers, setOnlineUsers] = useState([]);
  const t = useRef(null);
  
  const getDarkModoe = useSelector(darkModes => darkModes )
  let getCompanyID = useSelector(compID => compID.checkedSessionReducer)
  let getmyinfo = useSelector(compID => compID.getMayInfoReducer)
  const [checked,setChecked] = useState(false)
  const [selectDays,setselectDays] = useState("everyDay")
  const [loopingStartDate,setloopingStartDate] = useState(new Date().toISOString().slice(0, 16))
  
  const [everythreedays,seteverythreedays] = useState(new Date())
const dispatch = useDispatch()
let onlineUSers = useSelector(onlineUSers => onlineUSers)

  useEffect(() => {
   
    socket.emit('pushmyid', getmyinfo.myinfo._id);
      
    
    socket.on('online', (users) => {
      setOnlineUsers(users);
    });
  
    return () => {
      
      socket.off('online');
      socket.off('disconnect');

      // socket.off('getNotify');

    
    };
  }, []);

  useEffect(() => {


    switch (prioritet) {
      case "Критический":
        
        setclassNameTask("urgentAndImportant");
        break;
      case "Важно":
       
        setclassNameTask("LilacClass");
        break;
      case "Срочно":
     
        setclassNameTask("yellowClass");
        break;
      default:
     
        setclassNameTask("greyClass");
    }
    setCurrentTask([
      {
        child,
        taskName,
        msg: message,
        comments,
        performer,
        startDate,
        endDate,
        status,
        metka,
        prioritet,
        ozon,
        wb,
        classNameTask,
        file,
        perfomerID,
        childPerfomer,
        taskInfo
      },
    ]);

    
  }, [
    comments,
    performer,
    templates,
    templatesArray,
    startDate,
    endDate,
    status,
    prioritet,
    metka,
    child,
    wb,
    ozon,
    taskName,
    file,
    perfomerID,
    childPerfomer,
    taskInfo,
    
  ]);


  let array = [];

  const setSubStack = (e) => {
   
    if (e.key === "Enter") {
      if (message.length > 0) {
        setChild([
          ...child,
          {
            child: [],
            taskName,
            msg: message,
            comments,
            performer,
            startDate,
            endDate,
            status,
            prioritet,
            file,
            taskInfo
          },
        ]);
  
        setMessage("");
        subTaskRed.current.style.overflow = "auto";
        console.log(child);
      }
     
    }
  };
  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  // здесь добавляем под задачу
  const setSubStackBTN = (e) => {
        if (message != "") {
          dispatch(fetchUsers())
          setChild([
            ...child,
            {
              child: [],
              taskName,
              msg: message,
              comments,
              performer,
              startDate,
              endDate,
              status,
              prioritet,
              file,
              taskInfo,
              key:getRandomInt(1000000000000000000)
            },
          ]);
      
          setMessage("");
          subTaskRed.current.style.overflow = "auto";
          console.log(child);
        } 
   
  };

  const getarraa = (item, index) => {
    if (item.child.length === 0) {
      array = [];
      array.push(child);
      array[0][index].child.push();
    }
  };



// отправляем на сервер чтобы создать задачу
  const sendServer = (task,metka) => {
     
    setLoad(true)
    setperfomerID([...perfomerID,getmyinfo.myinfo])
    axios.post('/createTask/api', {
      CompanyID:getCompanyID.checkedSession,
       message ,
       task,
       creatorTask:getmyinfo.myinfo._id,
       perfomerID,
       allmetka:metka,
       isLooping:checked,
       selectDays,
       loopingStartDate,
       everythreedays
    })
    .then(function (response) {
  
       socket.emit('message', { room:getCompanyID.checkedSession, message ,task});
       setLoad(false)
       console.log(response);
       socket.emit('getNotifyEmit');
       navigate("/task")
    })
    .catch(function (error) {
      console.error(error);
      setLoad(false)
    });
  
    setMessage('');
  };


  const HandleSetPerfomerId=(e)=>{
 
    setperfomerID([e])
      setperformer(e)
  }

  const HandleDeletePerfomerId=(e)=>{
    setperformer("")
    setperfomerID([])
  }

  // здесь удалить подзадачу
  function deleteItemByIndex(index) {
    setChild(prevArray => {
      const newArray = [...prevArray]; // Create a new array copy
      newArray.splice(index, 1); // Remove the element at the specified index
      return newArray; // Update the state with the modified array
    });
  }

  const handleChangeFile=(e)=>{
        setfile(e)
  }




  return (
    <div   className={getDarkModoe.ToggleDarkModeReducer.chekced?"CreatTaskDark":"CreatTask"} >
       
     <div className="perfomerAndShef">
            <div>
            <Perfomer  setperfomerID={setperfomerID} HandleSetPerfomerId={HandleSetPerfomerId} HandleDeletePerfomerId={HandleDeletePerfomerId} onlineUsers={onlineUsers} getperformer={onlineUSers.getOnlineUserViaRouterReducer.users.data}/>
            </div>
     <div className="StatusPrioritetCont" style={{width:"100%"}}>
                <div style={{display:"flex",width:"20%",justifyContent:"space-evenly",marginLeft:"4%"}}>
                    <Status setStatus={setStatus} status={status} />
                    <Prioritet setPrioritet={setPrioritet} prioritet={prioritet}/>
                </div>
                <div  className="addTaskShablonDiv">
              <Shablon sendMessage={sendMessage} currentTask ={currentTask} perfomerID={perfomerID} receivedMessages={receivedMessages}  handleDelet={handleDelet} delLoad={delLoad} update={update} handleGetNotify={handleGetNotify} closeParent={handleClose}/>
              </div>
             </div>
             
     </div>

      <div className="inputCreatTask">
       
            <div className="taskinputsDiv">
            <Metka setMetka={setMetka} metka={metka} />
            <p className="taskName">Введите название задачи</p>
            <input
                placeholder="Введите название задачи"
                className="nameTaskInput"
                value={taskName}
                onChange={(e) => satTtaskName(e.target.value)}
                rows="1"
              />
            
              {/* date */}
              <div style={{margin: "30px 0px"}}>
              <p className="srok">Сроки</p>
              <div className="date">
                <label htmlFor="" className="startDate">
                Дата начала:
                  <input
                    size="sm"
                    type="datetime-local"
                    colorScheme="grey"
                    defaultValue={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                   
                  />
                </label>
                <label htmlFor="">
                Дата конца:
                  <input
                    size="sm"
                    type="datetime-local"
                    defaultValue={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </label>
                     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path d="M9.5 20H2.5C1.39 20 0.5 19.1 0.5 18L0.51 4C0.51 2.9 1.39 2 2.5 2H3.5V1C3.5 0.45 3.95 0 4.5 0C5.05 0 5.5 0.45 5.5 1V2H13.5V1C13.5 0.45 13.95 0 14.5 0C15.05 0 15.5 0.45 15.5 1V2H16.5C17.6 2 18.5 2.9 18.5 4V10H16.5V8H2.5V18H9.5V20ZM19.63 14.99L20.34 14.28C20.73 13.89 20.73 13.26 20.34 12.87L19.63 12.16C19.24 11.77 18.61 11.77 18.22 12.16L17.51 12.87L19.63 14.99ZM18.92 15.7L13.91 20.71C13.73 20.89 13.47 21 13.21 21H12C11.72 21 11.5 20.78 11.5 20.5V19.29C11.5 19.02 11.61 18.77 11.79 18.58L16.8 13.57L18.92 15.7Z" fill="#3B79F6"/>
                  </svg>
              </div>
              </div>
            {/* date End */}

            <LoopingTask setChecked={setChecked} checked={checked}  selectDays={selectDays} setselectDays={setselectDays} loopingStartDate={loopingStartDate} 
            setloopingStartDate={setloopingStartDate} everythreedays={everythreedays} seteverythreedays={seteverythreedays} creatTaskadminInfo={getmyinfo.myinfo
              }/>
           
              <p className="taskDeskriptionText">Добавьте описание задачи</p>
              <textarea placeholder="Добавьте описание задачи" className="taskDeskription" style={{marginBottom:"10px"}} onChange={(e) => setTasktaskInfo(e.target.value)}/>
              <SelectMarketPlace setBw={setBw} setOzon={setOzon} />
            
   
              
             
             
              <UploadFileTaskMeneger file={file} setfile={setfile} handleChangeFile={handleChangeFile}/>
            </div>

            <div className="taskinputsDiv2">
                  
              

             
              
            <div className="addSubTask">
              <p style={{ color: '#6A717F' }}>Подзадачи</p>
              <div>
                <input
                  className="SubTaskInput"
                  placeholder="Введите название подзадачи"
                  value={message}
                  onKeyDown={setSubStack}
                  onChange={(e) => setMessage(e.target.value)}
                />
                <button className="addTaskButton" onClick={(e) => setSubStackBTN(e.target.value)}>Добавить</button>
              </div>

            </div>

                   <div
                  className={getDarkModoe.ToggleDarkModeReducer.chekced?"subTaskDark":"subTask"}
                      style={{ overflow: "auto" }}
                      ref={subTaskRed}
                    >
                      {currentTask[0]?.child?.map((item, index) => {
                       
                          
                        return (
                          <div onClick={() => getarraa(item, index)} className={getDarkModoe.ToggleDarkModeReducer.chekced?"childTaskContDark":"childTaskCont"} >
                              <div className="itemChild">
                           
                            
                             
                             
                                <ChilMNodal
                                  item={item}
                                  allaray={currentTask}
                                  nameCurrentSubTask={item.msg}
                                  sendServer={sendServer}
                                  setperfomerID={setperfomerID}
                                  setchildPerfomer={setchildPerfomer}
                                  handleClose={handleClose}
                                  deleteItemByIndex={deleteItemByIndex}
                                  index={index}
                                  metkas={metka}
                                  load={load}
                                />
                           </div>
                                {/* <span class="material-symbols-outlined deletSubTusk" onClick={()=> deleteItemByIndex(index)}>delete</span> */}
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none"  onClick={()=> deleteItemByIndex(index)} className="deletSubTASK">
  <path d="M3.08594 13.2509C2.73145 13.2509 2.42798 13.1466 2.17554 12.9379C1.9231 12.7293 1.79688 12.4785 1.79688 12.1855V2.06481H0.916016V0.999467H4.95508V0.466797H10.627V0.999467H14.666V2.06481H13.7852V12.1855C13.7852 12.4696 13.6562 12.7182 13.3984 12.9313C13.1406 13.1444 12.8398 13.2509 12.4961 13.2509H3.08594ZM12.4961 2.06481H3.08594V12.1855H12.4961V2.06481ZM5.36328 10.6586H6.65234V3.57404H5.36328V10.6586ZM8.92969 10.6586H10.2187V3.57404H8.92969V10.6586Z" fill="#E62E7B"/>
</svg> */}
                          </div>
                        );
                      })}
                    </div>
                   
              <CommentBoxCreatTask setComments={setComments} comments={comments} />
             
            </div>
          </div>
          <div className="footerCreatTask">
                  {
                    load?
                    <button colorScheme="blue" onClick={() => sendServer(currentTask,metka)}>
                    Загрузка
                  </button>
                    :
                    <button colorScheme="blue" onClick={() => sendServer(currentTask,metka)}>
            Создать задачу
          </button>
                  }
         
          </div>
    
    </div>
  );
}

export default CreatTask;
